import { inject, Injectable, signal } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { tap } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  readonly #router = inject(Router);
  public breadcrumbs = signal<MenuItem[]>([]);

  constructor() {
    this.#router.events
      .pipe(
        tap((res) => {
          if (res instanceof NavigationEnd) {
            this.breadcrumbs.set([]);
            this.#createBreadCrumps(this.#router.routerState.snapshot.root);
          }
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  #createBreadCrumps(routes: ActivatedRouteSnapshot) {
    let breadcrumbs: MenuItem[] = [];
    this.#generateBreadCrumbPath(routes, breadcrumbs);
    this.breadcrumbs.set(breadcrumbs);
  }

  #generateBreadCrumbPath(
    route: ActivatedRouteSnapshot,
    breadcrumbs: MenuItem[],
  ): void {
    const breadcrumb = route.data['breadcrumb'];
    if (breadcrumb) {
      breadcrumbs.push({
        label: breadcrumb,
        route: this.#buildFullPath(route),
      });
    }
    if (route.firstChild) {
      this.#generateBreadCrumbPath(route.firstChild, breadcrumbs);
    }
  }

  #buildFullPath(route: ActivatedRouteSnapshot): string {
    const segments: string[] = [];
    let currentRoute: ActivatedRouteSnapshot | null = route;
    while (currentRoute) {
      if (currentRoute.url.length) {
        segments.unshift(...currentRoute.url.map((s) => s.path));
      }
      currentRoute = currentRoute.parent;
    }
    return '/' + segments.join('/');
  }
}
